module.exports = __webpack_public_path__ + "img/planning-ppp-1.8aa32dc0.png";